const inventoryManagementConstantsEn = {
  inventoryManagementMediaId: 'Media Id',
  inventoryManagementThumbnail: 'Thumbnail',
  inventoryManagementTitleHeader: 'Inventory Management',
  inventoryManagementTitle: 'Title',
  inventoryManagementDate: 'Updated date',
  inventoryManagementEdit: 'Actions',
  InventoryManagementToolTip: 'Inventory Management',
  inventoryManagementEditButton: 'Edit',
  inventoryManagementErrorSnackBar: 'Something Went Wrong !',
  inventoryManagementDeleted: 'Trash',
  totalInventoryItems: 'Inventory items',
  totalVideos: 'Videos',
  inventoryVideoType: 'Video',
  inventoryAudioType: 'Audio',
  inventoryFileType: 'File Type',
  inventoryLoadMoreButton: 'Load More...',
  publishedIconTitle: 'Published',
  publishedFilterTitle: 'Publish Status',
  publishedFilter: 'Published',
  unpublishedFilter: 'Unpublished',
};

export default inventoryManagementConstantsEn;
